import React from "react";
import MemberSearchForm from "containers/member/memberSearchForm";

import axios from 'axios';
import '../../form.css';

import { Table, Tag, Typography, Button, Layout, Row, Col, Divider, Spin, Avatar } from 'antd';
import {
	UserOutlined,
	EyeOutlined,
} from '@ant-design/icons';
import { Link } from "react-router-dom";

const { Content } = Layout;
const { Title } = Typography;

export default class MemberList extends React.Component {

	constructor(props: any) {
		super(props);
		this.getMembers();
	}

	state = {
		memberData: [],
		userInfo: [],
		loading: true,
		drawerVisible: false,
		total: 0
	};

	getMembers = () => {
		axios.get('https://www.fastmock.site/mock/9973669a2a13cbb70690fdf6f1880e97/admin/member/list', {
			params: {}
		})
			.then((res: any) => {
				console.log('res', res.data.data.list)
				this.setState({
					memberData: res.data.data.list,
					total: res.data.data.total,
					loading: false
				})
			})
			.catch((err: any) => {
				console.log(err)
			})
	}

	columns = [
		{
			title: 'Avatar',
			dataIndex: 'name',
			render: (text: React.ReactNode, record: any) => {
				return (
					<Avatar size="large" icon={<UserOutlined />}></Avatar>
				)
			}
		},
		{
			title: '会员信息',
			dataIndex: 'name',
			key: 'name',
			render: (text: React.ReactNode, record: any) => <div><a>{text}</a><br />{record.phoneNumber}</div>
		},
		{
			title: '来源',
			dataIndex: 'thirdPlatformName',
			key: 'thirdPlatformName',
			render: (text: React.ReactNode, record: any) => <div>{text}</div>,
		},
		{
			title: 'Email',
			dataIndex: 'email',
			key: 'email'
		},
		{
			title: 'QQ/微信',
			dataIndex: 'wechat',
			key: 'wechat',
			render: (text: React.ReactNode, record: any) => <div><div>{record.qq}</div><div>{text}</div></div>
		},
		{
			title: '等级',
			dataIndex: 'level',
		},
		{
			title: '猫粮',
			dataIndex: 'score'
		},
		{
			title: '订单',
			dataIndex: 'hasOrder',
			render: (text: number) => {
				if (text === 1) {
					return '有';
				}
			}
		},
		{
			title: '注册时间',
			dataIndex: 'registerTime',
			key: 'registerTime'
		},
		{
			title: '操作',
			dataIndex: 'userId',
			render: (text: React.ReactNode) => <Link to={{ pathname: `members/detail/${text}` }} target="_blank"><Button shape="round" key={`a-${text}`}><EyeOutlined />查看</Button></Link>,
		}
	];

	onClose = () => {
		this.setState({
			drawerVisible: false,
		});
	};

	render() {
		let userInfo: any = this.state.userInfo;
		console.log('userInfo', userInfo);
		return (
			<div>
				<div className="page-title">
					<Title level={3}>会员列表</Title>
				</div>

				<Divider />
				<MemberSearchForm></MemberSearchForm>

				<Spin tip="Loading..." size="large" spinning={this.state.loading}>
					<Table

						columns={this.columns}
						dataSource={this.state.memberData}
						pagination={{
							total: this.state.total,
							position: ["bottomLeft"],
						}}
						scroll={{
							x: 1000
						}}
					/>
				</Spin>
			</div>
		);
	}
}
